<mat-accordion class="marge" #MyProp>
    <!-- #enddocregion basic-panel -->
    <mat-expansion-panel [expanded]="panelOpenState === true" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
        
        <mat-expansion-panel-header>
            <mat-panel-title>
                {{Question.title}}
            </mat-panel-title>
            <mat-panel-description *ngIf="response">
                {{response}}
            </mat-panel-description>
            <div class="valid" *ngIf="show">Répondu</div>
            <div class="invalid" *ngIf="!show">En cours</div>
        </mat-expansion-panel-header>

        <mat-form-field appearance="fill" class="hour-width" *ngIf="Question.displayDateMode == 3">
            <mat-label>Choississez une date</mat-label>
            <input matInput [matDatepicker]="picker" [(ngModel)]="date" (ngModelChange)="searchLink()">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        
        <div *ngIf="Question.displayDateMode == 4">
            <mat-form-field appearance="fill">
                <mat-label>Choississez une date</mat-label>
                <input matInput [matDatepicker]="picker" [(ngModel)]="startDate" (ngModelChange)="searchLink()">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="fill" style="margin-left: 15px;">
                <mat-label>Choississez une date</mat-label>
                <input matInput [matDatepicker]="picker1" [(ngModel)]="endDate" (ngModelChange)="searchLink()">
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>
        </div>
    </mat-expansion-panel>
</mat-accordion>


<div *ngIf="questions.length > 0 && show">
    <div *ngFor="let q of questions">
        <app-generic-display [Question]="q" [SurveyBase]="SurveyBase"></app-generic-display>
    </div>
</div>